document.addEventListener('DOMContentLoaded', function () {

    const popup = document.getElementById('gt-choice-popup');
    if (!popup) return;

    const closeBtn = popup.querySelector('.gt-choice-close');
    const overlay = popup.querySelector('.gt-choice-overlay');
    const eyewearCard = popup.querySelector('.gt-eyewear-card');
    const labCard = popup.querySelector('.gt-lab-card');

    const storageKey = 'gtChoicePopupSeen';

    // Popup will not show again for 12 hours
    const popupExpiry = 12 * 60 * 60 * 1000;

    function markPopupAsSeen() {
        localStorage.setItem(storageKey, Date.now().toString());
    }

    function hasSeenPopupRecently() {
        const lastSeen = localStorage.getItem(storageKey);

        if (!lastSeen) {
            return false;
        }

        const lastSeenTime = parseInt(lastSeen, 10);

        if (isNaN(lastSeenTime)) {
            localStorage.removeItem(storageKey);
            return false;
        }

        const timePassed = Date.now() - lastSeenTime;

        return timePassed < popupExpiry;
    }

    function closePopup() {
        popup.classList.remove('active');
        markPopupAsSeen();
    }

    // Show popup only if it has not been seen recently
    if (!hasSeenPopupRecently()) {

        setTimeout(function () {

            popup.classList.add('active');

            // Mark as seen as soon as it appears
            markPopupAsSeen();

            // Automatically close after 12 seconds
            setTimeout(function () {
                if (popup.classList.contains('active')) {
                    closePopup();
                }
            }, 12000);

        }, 700);

    }

    // Close button
    if (closeBtn) {
        closeBtn.addEventListener('click', closePopup);
    }

    // Overlay
    if (overlay) {
        overlay.addEventListener('click', closePopup);
    }

    // GT Eyewear
    if (eyewearCard) {
        eyewearCard.addEventListener('click', function (e) {
            e.preventDefault();
            closePopup();
        });
    }

    // GT Optical Lab
    if (labCard) {
        labCard.addEventListener('click', function (e) {

            e.preventDefault();

            const labUrl = this.href;

            // Close popup first
            closePopup();

            // Open Optical Lab in a new tab
            window.open(labUrl, '_blank', 'noopener,noreferrer');

        });
    }

});